import { formatPhoneNumbers, formatEmails } from "../../../utils";

export const formatedPayload = (data) => {
  const { emails, phones, coverageAreas, ...rest } = data;

  const formattedPhoneNumbers = formatPhoneNumbers(phones);
  const formattedEmails = formatEmails(emails);

  return {
    ...rest,
    emails: formattedEmails,
    phoneNumbers: formattedPhoneNumbers,
    coverageAreas: Array.isArray(coverageAreas)
      ? coverageAreas.map((a) => ({
          state: a.state,
          city: a.city,
          country: a.country,
          zipCode: a.zipCode,
          address: a.address,
          latitude: a.latitude,
          longitude: a.longitude,
          milesOfCoverageArea: a.milesOfCoverageArea || 0,
        }))
      : [],
    ratePerHour: data?.ratePerHour?.toString() || "0",
  };
};
